var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5324C1 12.7393 2.19327 11.1653 3.91974 10.681L36.9197 1.42495C39.4708 0.709421 42 2.62685 42 5.27632V34.9676C42 36.7607 40.8067 38.3347 39.0803 38.819L6.08026 48.075C3.52924 48.7906 1 46.8731 1 44.2237V14.5324Z",
    stroke: "#E3E3E3",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5C1 13.2909 2.79086 11.5 5 11.5H45C47.2091 11.5 49 13.2909 49 15.5V45.5C49 47.7091 47.2091 49.5 45 49.5H5C2.79086 49.5 1 47.7091 1 45.5V15.5Z",
    fill: "none",
    stroke: "#E3E3E3",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.5C30 26.634 33.134 23.5 37 23.5H50C51.1046 23.5 52 24.3954 52 25.5V35.5C52 36.6046 51.1046 37.5 50 37.5H37C33.134 37.5 30 34.366 30 30.5Z",
    fill: "none",
    stroke: "#E3E3E3",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 30.5,
    r: 3,
    stroke: "#E3E3E3",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.60781a8c90c6cd0b6af456506112d1fc.svg";
export { ForwardRef as ReactComponent };